import { NJIconButton, NJBadge } from '@engie-group/fluid-design-system-react';
import { UM } from '../_components/tokens';
import type { LayerItem } from './types';

/** Ligne de couche réutilisée par les deux propositions (A et B). */
export function LayerRow({
  layer,
  onToggleVisibility,
  onToggleFavorite,
}: {
  layer: LayerItem;
  onToggleVisibility: (id: string) => void;
  onToggleFavorite: (id: string) => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 4px',
        borderRadius: 4,
      }}
    >
      <NJIconButton
        icon={layer.isFavorite ? 'star' : 'star_border'}
        label={layer.isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
        scale="sm"
        variant="tertiary"
        onClick={() => onToggleFavorite(layer.id)}
      />

      <span
        style={{
          flex: 1,
          fontSize: 13,
          color: layer.visible ? UM.text : UM.textDim,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {layer.label}
      </span>

      {layer.isEngieInternal && (
        <NJBadge variant="information" scale="sm">ENGIE</NJBadge>
      )}

      <NJIconButton
        icon={layer.visible ? 'visibility' : 'visibility_off'}
        label={layer.visible ? 'Masquer la couche' : 'Afficher la couche'}
        scale="sm"
        variant="tertiary"
        onClick={() => onToggleVisibility(layer.id)}
      />
    </div>
  );
}
